import createEnum from 'scripts/lib/create_enum';
import createModel, { prop } from './lib/create_model';

export const OrganizationType = createEnum('STANDALONE', 'TEAM');

const Organization = createModel({
  modelName: 'Organization',
  properties: {
    id: prop(String),
    loginDomain: prop(String),
    gladlyUrl: prop(String),
    isSidekickEnabled: prop(Boolean),
    type: prop(String).default(OrganizationType.TEAM),
    billingDetails: prop(Object).default({}),
  },

  setSidekickEnabled(isEnabled) {
    this.isSidekickEnabled = isEnabled;
  },

  getTrialEndDate() {
    return this.billingDetails.trialEndAt;
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default Organization;
